export default __webpack_public_path__ + "static/savings-650b9e01a8891ec2bcb6b68b3d0004cd.png";